import { authApiHandler } from '../services/authApi'
import { AuthConfig } from '../types/types'

// Browser only. The server route switches the tokens and sets the contact cookie.
export default (config: AuthConfig) => {
  const authApi = authApiHandler(config)

  return async (contactId: number): Promise<boolean> => {
    if (typeof window === 'undefined') return false

    const result = await authApi.postAuthRoute<{ contactId: number }>('contact', { contactId })

    return (result?.contactId ?? 0) > 0
  }
}
